import { useEffect, useState } from 'react';
import { AppWatch } from '@wajeez/wajeez.microservices';
import {
  useAppwatchSelector,
  useAppwatchDispatch,
  PaymentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartDisplay } from '@wajeez-web/components/ui';
import { ChartHeader } from '../ChartHeader';
import { ChartsProps } from '../types';
import moment from 'moment';

const DailyReactivedPremiumUsersChart = ({ dates }: ChartsProps) => {
  const dispatch = useAppwatchDispatch();
  const { dailyReactivedPremiumUsers, dailyReactivedPremiumUsersStatus } =
    useAppwatchSelector((c) => c.paymentAnalysis);
  const [subscriptionDuration, setSubscriptionDuration] =
    useState<AppWatch.SubscriptionDuration | null>(null);
  const [purchaseSource, setPurchaseSource] =
    useState<AppWatch.PurchaseSourceType>(
      AppWatch.PurchaseSourceType.CARD_DIRECT
    );

  useEffect(() => {
    dispatch(
      PaymentAnalysisActions.getdailyReactivedPremiumUsersAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
        purchaseSourceType: purchaseSource,
        SubscriptionPeriod: subscriptionDuration ?? undefined,
      })
    );
  }, [dates, purchaseSource, subscriptionDuration]);

  return (
    <div className="col-span-1">
      {' '}
      <Card>
        <div className="space-y-2">
          <ChartHeader
            title="Daily Reactived Premium Users"
            dates={dates}
            subscriptionDuration={subscriptionDuration}
            PurchaseSourceAction={(purchaseSource) =>
              setPurchaseSource(purchaseSource)
            }
            SubscriptionDurationAction={(duration) =>
              setSubscriptionDuration(duration)
            }
            purchaseSource={purchaseSource}
            subTitle={
              dailyReactivedPremiumUsers?.total &&
              dailyReactivedPremiumUsersStatus !== 'loading'
                ? `المجموع: ${dailyReactivedPremiumUsers?.total}`
                : ''
            }
          />

          <ChartDisplay
            loading={dailyReactivedPremiumUsersStatus === 'loading'}
            formatter={(value, time) => {
              return (
                moment.utc(value).local().locale('en').format('DD/MM/YYYY') ||
                value
              );
            }}
            // xAxistype="datetime"
            chartType="area"
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            seriesData={[
              {
                type: 'area',
                name: 'Users',
                data:
                  dailyReactivedPremiumUsers?.items?.map((element) => ({
                    y: element.count || 0,

                    x: element.startDate || '',
                  })) || [],
              },
            ]}
          />
        </div>
      </Card>
    </div>
  );
};

export default DailyReactivedPremiumUsersChart;
